import { useState, useEffect } from 'react';
import LoginService from '../services/LoginService';

const useLoginFetch = (props) => {
    const [response, setResponse] = useState(undefined);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(undefined);

    const { methodName, params = [] } = props || {};

    const performAction = async () => {
        try {
            const method = LoginService[methodName].bind(
                LoginService,
                ...params,
            );

            const res = await method();

            setResponse(res);
            setIsLoading(false);
        } catch (e) {
            setError(e);
            setIsLoading(false);
        }
    };

    useEffect(() => {
        performAction();
    }, []);

    return { response, isLoading, error };
};

export default useLoginFetch;
